import { post, ServiceResult } from "@insite/client-framework/Services/ApiService";

export interface BrickQuoteApiParameter {
	type: string;
	emailTo: string;
	firstName: string;
	lastName: string;
	companyName: string;
	emailAddress: string;
	phoneNumber: string;
	city: string;
	province: string;
	message: string;
	quoteLines: QuoteLine[];
}

export interface QuoteLine {
	productId: string;
	name: string;
	attributes: Attributes;
	imageUrl: string;
}

export interface Attributes {
	[Key: string]: string;
}

export interface BrickModel {
	quoteCartId?: string;
}

const brickUrl = "/api/v1/communication"

export async function brickService(parameter: BrickQuoteApiParameter): Promise<ServiceResult<BrickModel>> {
	try {
		const birckModel = await post<BrickModel>(`${brickUrl}`, parameter as BrickModel);
		return {
			result: birckModel,
			successful: true,
		};
	} catch (error) {
		if ("status" in error && error.status === 400 && error.errorJson && error.errorJson.message) {
			return {
				successful: false,
				errorMessage: error.errorJson.message,
			};
		}
		throw error;
	}
}